/*
 * @Author: jay
 * @Date: 2021-08-24 20:02:28
 * @LastEditTime: 2021-08-26 17:16:10
 * @Description: file content
 */
import { FC, useMemo, useEffect, useState } from "react";
import { Menu, Dropdown } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import { DownOutlined } from "@ant-design/icons";
import IconFont from "../iconFont";
import { removeCookie } from "@/utils";
import userImg from "../../assets/common/user.png";
import styles from "./style.module.less";
import PubSub from "pubsub-js";
import HocPageAuthority from "../HOC/HocPageAuthority";

const Header: FC<any> = ({ menusTpye = [], isShunwan }) => {
  const [info, setInfo] = useState<any>(null);
  const history = useHistory();
  const locations = useLocation();
  const pressHandle = (key: string) => {
    history.push(`/${key}`);
  };

  const [isFullScreen, setIsFullScreen] = useState<boolean>(JSON.parse(sessionStorage.getItem("isFullScreen") || "false"));

  const logout = () => {
    window.localStorage.removeItem("user");
    removeCookie("accessToken");
    removeCookie("refreshToken");
    history.push("/login");
  };
  const menu = (
    <Menu>
      <Menu.Item key="0">
        <span onClick={logout} className={styles.item}>
          退出登录
        </span>
      </Menu.Item>
    </Menu>
  );
  const navMenu = useMemo(() => {
    if (locations.pathname.includes("login")) {
      return "";
    }
    return (
      <>
        <div className={styles.menubox}>
          {menusTpye().map(({ key, title, icon }: any) => {
            const flag = locations.pathname.includes(key);
            return (
              <div key={key} className={flag ? styles.active : ""} onClick={() => pressHandle(key)}>
                <IconFont type={icon} />
                <span>{title}</span>
              </div>
            );
          })}
        </div>
      </>
    );
  }, [locations, menusTpye]);

  const loadUser = () => {
    if (localStorage.getItem("user")) {
      const user = JSON.parse(localStorage.getItem("user") as any);
      setInfo(user);
    }
  };

  const handleIsFullScreen = () => {
    const isFullScreen = sessionStorage.getItem("isFullScreen");
    if (isFullScreen === null) {
      sessionStorage.setItem("isFullScreen", "true");
      setIsFullScreen(true);
      window.dispatchEvent(new Event("storage"));
      return;
    }
    sessionStorage.setItem("isFullScreen", !JSON.parse(isFullScreen) + "");
    setIsFullScreen(!JSON.parse(isFullScreen));
    window.dispatchEvent(new Event("storage"));
  };

  useEffect(() => {
    loadUser();
  }, [locations]);

  useEffect(() => {
    const token = PubSub.subscribe("changeUser", () => loadUser());
    return () => {
      PubSub.unsubscribe(token);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("storage", () => {
      setIsFullScreen(JSON.parse(sessionStorage.getItem("isFullScreen") || "false"));
    });

    return () => {
      window.removeEventListener("storage", () => {
        console.log("退出");
      });
    };
  }, []);

  return (
    <div className={styles.headWrap}>
      <div className={isFullScreen ? styles["fullScreen-layout"] : ""}>
        <div className={styles.left}>
          {
            window.isJieji ? <div className="logoJieji"></div> : window.isAf ? <div className="logoAf"></div> : <div className={isShunwan ? "logoShun" : "logo"}></div>
          }
          
          {navMenu}
        </div>
        {locations.pathname.includes("login") ? (
          ""
        ) : (
          <div className={styles.right}>
            <img src={info?.headimg || userImg} alt="" />
            <Dropdown overlay={menu} placement="bottomCenter" arrow trigger={["click"]}>
              <span>
                {info?.nickname || info?.phone || info?.username}
                <DownOutlined />
              </span>
            </Dropdown>
          </div>
        )}
      </div>
      <div className={isFullScreen ? styles.notFullScreenBtn : styles.fullScreenBtn} onClick={() => handleIsFullScreen()}></div>
    </div>
  );
};

export default HocPageAuthority(Header);
